import { Navigate } from "react-router-dom";

// ==========================================
// ProtectedRoute
// ==========================================
// الغرض: منع فتح أي صفحة عن طريق كتابة الرابط مباشرة في المتصفح
// إلا لو المستخدم فعلاً معاه صلاحية الوصول لها (مش بس مخفية من الـ Sidebar)
//
// طريقة الاستخدام في App.jsx:
//
//   <Route
//     path="/reports"
//     element={
//       <ProtectedRoute page="/reports">
//         <Reports />
//       </ProtectedRoute>
//     }
//   />
//
// ملاحظة: prop اسمه "page" لازم يطابق نفس المسار المستخدم في allowedPage
// بتاع المستخدم (نفس القيم الموجودة في availablePages داخل Users.jsx)

const ADMIN_ROLE_ID = 1;
const DEFAULT_USER_PAGE = "/SupportdSec1";

const ProtectedRoute = ({ page, children }) => {
  const token = localStorage.getItem("token");
  const rawUser = localStorage.getItem("user");
  const user = rawUser ? JSON.parse(rawUser) : null;

  // 1. مفيش تسجيل دخول أصلاً
  if (!token || !user) {
    return <Navigate to="/" replace />;
  }

  const isAdmin = Number(user.roleId) === ADMIN_ROLE_ID;
  const allowedPage = user.allowedPage ? user.allowedPage.toLowerCase() : null;
  const currentPage = (page || "").toLowerCase();

  // 2. حالة خاصة: المستخدم مقيّد بصفحة واحدة بس (allowedPage)
  //    ده بيتغلّب حتى لو المستخدم أدمن
  if (allowedPage) {
    if (allowedPage === currentPage) {
      return children;
    }
    // مش مسموح له بالصفحة دي -> رجّعه لصفحته المسموح بيها هو بس
    return <Navigate to={user.allowedPage} replace />;
  }

  // 3. مفيش تقييد خاص -> الأدمن يدخل أي صفحة
  if (isAdmin) {
    return children;
  }

  // 4. مستخدم عادي (مش أدمن) بدون تقييد خاص -> يدخل بس شاشة الدعم الافتراضية
  if (currentPage === DEFAULT_USER_PAGE.toLowerCase()) {
    return children;
  }

  // 5. أي حالة تانية: امنعه وارجعه لصفحته الافتراضية
  return <Navigate to={DEFAULT_USER_PAGE} replace />;
};

export default ProtectedRoute;
